import { jsx as _jsx } from "react/jsx-runtime";
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { useCopyAPIKeyIntegration } from '../CopyAPIKeyModal/useCopyAPIKeyIntegration';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
import AbacorLogo from '../logos/abacor.svg';
export const GetAbacorCardTID = (parentTestId)=>getTestIds(parentTestId);
const { AbacorCardTID } = GetAbacorCardTID();
export function AbacorCard() {
    const { t: abacorTexts } = useLocaleKeys('integrations.availableApps.abacor');
    const { t: sharedTexts } = useLocaleKeys('integrations.availableApps.shared');
    const { showCopyAPIKeyModal } = useCopyAPIKeyIntegration('abacor');
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: AbacorCardTID.Card(),
        icon: /*#__PURE__*/ _jsx(AbacorLogo, {
            width: 40,
            height: 40
        }),
        title: abacorTexts.title(),
        subTitle: abacorTexts.subTitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            bi: {
                name: 'connect_abacor'
            },
            onClick: showCopyAPIKeyModal,
            testId: AbacorCardTID.Connect(),
            children: sharedTexts.connectButton()
        })
    });
}
